import Education from "../education/Education";
import React, { useState } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { motion } from "framer-motion";

const EducationCollapse = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="bg-white">
      <div className="mx-auto w-[90%] py-8 lg:w-[80%]">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ druation: 2, delay: 3 }}
          className="flex flex-col items-center justify-center space-y-8"
        >
          {/* TITLE */}
          <div className="text-2xl font-extrabold text-blue-500 lg:text-3xl xl:text-4xl">Tanulmányaim</div>
          {/* SEPARATOR */}
          <div className="mx-auto flex w-full items-center justify-center space-x-5">
            {/* LEFT LINE */}
            <div className="h-[2px] w-[20%] bg-blue-500"></div>
            {/* COLLAPSE BUTTON */}
            <button onClick={toggleCollapse} className="flex items-center justify-between text-blue-600">
              {isOpen ? (
                <FaChevronUp className="transform transition-transform duration-300" />
              ) : (
                <FaChevronDown className="transform transition-transform duration-300" />
              )}
            </button>
            {/* RIGHT LINE */}
            <div className="h-[2px] w-[20%] bg-blue-500"></div>
          </div>
          {/* COLLAPSABLE CONTENT */}
          <div
            className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${isOpen ? "max-h-[200vh]" : "max-h-0"}`}
          >
            <Education />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default EducationCollapse;
